import { globalModel } from '@/model'

export function getServerDate() {
  return new Date(Date.now() + globalModel.state.serverTimeDiff)
}
